export class MedalliaTracking {
    operationtype: string;
    userId: string;
    combinedValue: string;
    source: string;
    segment: string;
    Partnernumber: string;
    Typecontract: string;
    FlagPack: string;
    FlagCC: string;
    FlagMobility: string;
    FlagSolar: string;
    FlagFE: string;
    FlagDD: string;
}
